import styled from 'styled-components';

const Content = styled.div`
  padding: ${props => props.active ? '1.75rem' : '1.875rem'};

  @media (max-width: 75rem) {
    padding: ${props => props.active ? '1.125rem' : '1.25rem'};
  }

  ${props => {
    if (props.focusable) {
      return `
        :focus-within {
          padding: 1.75rem;

          @media (max-width: 75rem) {
            padding: 1.125rem;
          }
        }
      `;
    }
  }}
`;

export default Content;